import React, { useState, useRef, useEffect } from 'react'
import styles from './CustomDropDown.module.css';
export default function CustomDropDown({ list, onSelect, selectedOption, displayKey, width="23rem" }) {
  const [isOpen, setIsOpen] = useState(false)
  const dialogBox = useRef(null);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dialogBox.current && !dialogBox.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return (
    <>
        <div ref={dialogBox} className={styles.wrapper} style={{width:width}}>
          <div className={styles.lettertype} onClick={handleToggle} style={{ cursor: "pointer", width:"inherit" }}>
            <div className={styles.selectItem}>
              <p>{displayKey ? (selectedOption ? selectedOption[displayKey] : 'Select') : selectedOption.replace(/_/g," ").toUpperCase()}</p>
              {isOpen ? <img src='/chevrondown.svg' style={{ transform: "rotate(180deg)" }} /> : <img src='/chevrondown.svg' />}
            </div>
          </div>

          <div className={styles.customDropdown}>
            {isOpen && (
              <div className={styles.dropdownOptions}>
                {list.map((i, index) => (
                  <div key={index} className={styles.dropdownList} onClick={() => handleSelect(displayKey ? index : i)}>
                    {(displayKey ? i[displayKey] : i.subject? i.subject:i).replace(/_/g, " ").toUpperCase()}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
    </>
  )
}
